/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';

import {CardSnabbdom} from '../chart-card';

const STEP_SERIES = [
  {
    count: 44662,
    avg_time: null,
    avg_time_from_start: null,
    overall_conv_ratio: 1,
    step_conv_ratio: 1,
  },
  {
    count: 21219,
    avg_time: 334703,
    avg_time_from_start: 334703,
    overall_conv_ratio: 0.47510187631543593,
    step_conv_ratio: 0.47510187631543593,
  },
  {
    count: 20179,
    avg_time: 66254,
    avg_time_from_start: 396271,
    overall_conv_ratio: 0.45181586135864943,
    step_conv_ratio: 0.9509873226825015,
  },
  {
    count: 0,
    avg_time: null,
    avg_time_from_start: null,
    overall_conv_ratio: 0,
    step_conv_ratio: 0,
  },
];

const chartProps = (events: string[]) => ({
  cardTitle: `Sample Funnel`,
  chartOptions: {
    type: `funnel-steps`,
  },
  projectId: ``,

  bookmark: {
    type: `funnels`,
    dashboard: {},
    params: {
      stat_sig_control: [],
      chart_type: `chart`,
      count_type: `unique`,
      date_range: {
        type: `in the last`,
        from_date: {
          unit: `day`,
          value: 30,
        },
        to_date: `$now`,
      },
      time_comparison: null,
      exclusions: [],
      filter_by_cohort: `{}`,
      length: 30,
      length_unit: `day`,
      time_buckets: {
        min: 0,
        max: 2592000,
        offset: 0,
        bucket_size: 172800,
        is_drilled_down: false,
      },
      frequency_buckets: {
        min: 1,
        max: 20,
        offset: 0,
        bucket_size: 1,
      },
      trend_unit: `day`,
      trend_count_type: `linear`,
      funnel_order: `loose`,
      version: 2,
      steps: events.map((ev) => ({
        step_label: ev,
        event: ev,
        property_filter_params_list: [],
      })),
      savedLegend: [],
      selectedTableColumns: {
        'stat-sig': true,
        'conv-prev-step': true,
        'conv-first-step': false,
        count: true,
        'time-prev-step': true,
        'time-first-step': false,
      },
      ttcVizType: `Bar`,
      frequencyVizType: `Bar`,
      stepsVizType: `Steps`,
      ttcAggregateType: `Distribution`,
      frequencyAggregateType: `Distribution`,
      liftComparison: null,
      eventIndex: null,
      trendType: `conversion`,
      frequencyType: `Conversion`,
      ttcValueRepresentation: `relative`,
      frequencyValueRepresentation: `relative`,
      sorting: {
        sortBy: `value`,
        sortOrder: `desc`,
        valueField: `step-0`,
        colSortAttrs: [
          {
            sortBy: `value`,
            sortOrder: `desc`,
            valueField: `step-0`,
          },
        ],
      },
    },
    can_view: true,
  },
  chartParams: {
    computed_at: `2023-11-19T14:29:22.488119+00:00`,
    data: {
      '2023-10-20': {
        steps: events.map((ev, ind) => {
          return {...STEP_SERIES[ind], event: ev, goal: ev, step_label: ev};
        }),
        analysis: {
          completion: 0,
          starting_amount: 44662,
          steps: 4,
          worst: 3,
        },
      },
    },
    meta: {
      dates: [`2023-10-20`],
      property_values: [],
      min_sampling_factor: 1,
      group_by_metadata: [],
    },
    min_sampling_factor: 1,
  },
  dataGroups: null,
});

export const FunnelPreview = ({events}) => {
  //@ts-ignore
  return <CardSnabbdom params={chartProps(events)} />;
};
